import React from 'react';
import { Hidden, makeStyles } from '@material-ui/core';
import { Header } from '@swagup-com/components';
import { useHoliday } from '../../contexts/holiday';
import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';
import { isAllowed } from '../../helpers/utilsHeader';
import log from '../../logger';

const useStyles = makeStyles({
  root: {
    position: 'sticky',
    top: 0,
    zIndex: 1100
  }
});

const useHeaderStyles = makeStyles(theme => ({
  appBar: ({ darkMode, isDashboardHeader }) => ({
    position: 'static',
    display: 'flex',
    paddingRight: '0 !important', // material-ui popups adds padding-right: 17px to headers and body
    backgroundColor: darkMode ? '#091626' : '#ffffff',
    borderBottom: isDashboardHeader ? '1px solid #E5E7E8' : 'none'
  }),
  upperBar: {
    margin: 'auto',
    alignItems: 'center !important'
  },
  mainBar: {
    width: '100%',
    minHeight: 80,
    padding: '0px 80px',
    [theme.breakpoints.down('sm')]: {
      padding: '0px 8px'
    }
  },
  content: {
    width: '66%'
  }
}));

const TopBarContent = ({ pathname, isDashboardHeader }) => {
  const darkMode = useHoliday();
  const classes = useStyles();
  const headerClasses = useHeaderStyles({ darkMode, isDashboardHeader });

  log.debug('TopBarContent pathname, darkMode, isDashboardHeader:', pathname, darkMode, isDashboardHeader);

  return (
    isAllowed(pathname) && (
      <div id="header" className={classes.root}>
        <Header
          classes={headerClasses}
          logo={darkMode ? { link: '/', image: '/images/public/white-logo.svg' } : undefined}
        >
          <Hidden implementation="css" xsDown>
            <DesktopHeader isDashboardHeader={isDashboardHeader} pathname={pathname} />
          </Hidden>
          <Hidden implementation="css" smUp>
            <MobileHeader isDashboardHeader={isDashboardHeader} pathname={pathname} />
          </Hidden>
        </Header>
      </div>
    )
  );
};

export default TopBarContent;
